module.exports = __webpack_public_path__ + "media/application/images/svgs/more-vertical-ddfb9f4027661ecd115ad8d7cd6b3a82.svg";